// eslint-disable-next-line max-classes-per-file
import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { IAlertInfo } from '~/api/IAlertInfo';

export class Alert implements IAlertInfo {
  @Ref alertId?: string;
  @Ref alertCategory?: string;
  @Ref alertTypeId?: string;
  @Ref knownLocation: { id: string, value: string };
  @Ref googleLocationId?: string;
  @Ref address?: string;
  @Ref address2?: string;
  @Ref patientId?: string;
  @Ref alertText?: string;
  @Ref status?: string;
  @Ref createdTime?: string;
  @Ref updatedTime?: string;

  constructor(data: Partial<IAlertInfo>) {
    assignOwnProperties(this, normalize(data));
  }
}
